import React from 'react';
import {useMetadataSavedStatus} from 'services/metadata';
import {selectWorkItems, useSetWorkItems} from 'services/workItems';
import {useAppSelector} from 'store/hooks';
import {Layout, NextButton, ToolBar} from 'components';
import {ManifestationStatus} from './ManifestationStatus';

type Props = {
  onSearch: () => void;
};

export const MetadataToolbar: React.FC<Props> = ({onSearch}) => {
  const status = useMetadataSavedStatus();
  const workItems = useAppSelector(selectWorkItems);
  const setWorkItems = useSetWorkItems();

  return (
    <Layout horizontal adjustCenter adjustRight flex={1}>
      <ToolBar>
        <ManifestationStatus status={status} />
        <NextButton items={workItems} setter={setWorkItems} />
        <ToolBar.IconTool icon="Search" onClick={onSearch} />
      </ToolBar>
    </Layout>
  );
};
